/**
 * Broadcast / invalidación de site_settings entre admin y landings SPA.
 * Mismo patrón que PREMIUM_INVITE_CONFIG_UPDATED_LS_KEY.
 *
 * Tras guardar/publicar en Templates por país, las landings Mux (DualCTA,
 * InvitacionExclusivaMux) re-fetchean GET /api/site-settings y pueden
 * actualizar playback ID / VIP / free-TG sin redeploy.
 *
 * Coherencia: el listener de useSiteSettings hace hard fetch (no soft cache)
 * al oír este evento — no importamos el hook acá (evita ciclo de módulos).
 */

export const SITE_SETTINGS_UPDATED_LS_KEY = "site_settings_updated";

/** Notifica a otras pestañas (y al mismo origen) que live site_settings cambió. */
export function broadcastSiteSettingsUpdated(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(SITE_SETTINGS_UPDATED_LS_KEY, String(Date.now()));
  } catch {
    /* private mode / quota */
  }
  try {
    window.dispatchEvent(
      new CustomEvent(SITE_SETTINGS_UPDATED_LS_KEY, {
        detail: { at: Date.now() },
      }),
    );
  } catch {
    /* ignore */
  }
}
